import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import "./leave-request.css";
import { FaEye } from "react-icons/fa";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
let LeaveRequest = () => {
  const navigate = useNavigate();
  let TableData = [
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      teacherStudentName: "Willow Anderson",
      leaveTitle: "Lorem ipsum dolor sit a...",
      leaveDescription:
        "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      teacherStudentName: "Willow Anderson",
      leaveTitle: "Lorem ipsum dolor sit a...",
      leaveDescription:
        "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      teacherStudentName: "Willow Anderson",
      leaveTitle: "Lorem ipsum dolor sit a...",
      leaveDescription:
        "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
    },

    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      teacherStudentName: "Willow Anderson",
      leaveTitle: "Lorem ipsum dolor sit a...",
      leaveDescription:
        "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      teacherStudentName: "Willow Anderson",
      leaveTitle: "Lorem ipsum dolor sit a...",
      leaveDescription:
        "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      teacherStudentName: "Willow Anderson",
      leaveTitle: "Lorem ipsum dolor sit a...",
      leaveDescription:
        "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
    },

    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      teacherStudentName: "Willow Anderson",
      leaveTitle: "Lorem ipsum dolor sit a...",
      leaveDescription:
        "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
                <div>
                  <p className="header-input-heading">Search by title</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Search by title"
                  />
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={4} sm={5} xs={12}>
                <DateRangePicker />
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
                <Button className="header-apply-button" variant="text">
                  <p className="header-apply-button-text">Apply</p>
                </Button>
              </Grid>
              <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
            </Grid>
          </Box>
          <br />
          <div className="table-container">
            <div className="table-data-container">
              <table>
                <thead>
                <tr>
                  <th className="leave-request-table-id-heading">ID</th>
                  <th className="leave-request-table-start-date-heading">
                    Start Date
                  </th>
                  <th className="leave-request-table-end-date-heading">
                    End Date
                  </th>
                  <th className="leave-request-table-teacher-student-name-heading">
                    Teachers/student name
                  </th>
                  <th className="leave-request-table-leave-title-heading">
                    Leave Title
                  </th>
                  <th className="leave-request-table-leave-description-heading">
                    Leave Discription
                  </th>
                  <th className="leave-request-table-leave-view-heading"></th>
                </tr>
                </thead>
                {TableData.map((tableValue, tableIndex) => {
                  return (
                    <tr key={tableIndex}>
                      <td className="table-id-data">{tableIndex + 1}</td>
                      <td className="table-data">{tableValue.startDate}</td>
                      <td className="table-data">{tableValue.endDate}</td>
                      <td className="table-data">
                        {tableValue.teacherStudentName}
                      </td>
                      <td className="table-data">{tableValue.leaveTitle}</td>
                      <td className="table-data">
                        {tableValue.leaveDescription}
                      </td>
                      <td className="table-data">
                        <Button
                          className="leave-request-table-view-button"
                          variant="text"
                          onClick={() => navigate("/leave-request/view")}
                        >
                          <FaEye color="#000000" />
                          <p className="leave-request-table-view-button-text">
                            View
                          </p>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
            <div className="table-pagination-main">
              <Stack spacing={2}>
                <Pagination count={10} variant="outlined" shape="rounded" />
              </Stack>
            </div>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default LeaveRequest;
